module.exports = __webpack_public_path__ + "img/22.de4bb87e.jpg";